import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "排行榜", to: "/rank" },
  { label: "编辑推荐", to: "/recommend" },
  { label: "精选书单", to: "/booklist" },
  { label: "社区讨论", to: "/discussion" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;
    window.REACT_APP_NAVIGATE("/rank");
    setQuery("");
  };

  return (
    <header
      className={`sticky top-0 z-50 transition-all ${
        scrolled
          ? "bg-background-50/95 shadow-sm backdrop-blur border-b border-background-200/70"
          : "bg-background-50"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="笨狗漫画网 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-lg text-background-50">笨</span>
          <span className="font-heading text-xl md:text-2xl text-primary-600 leading-none">
            笨狗漫画网
          </span>
        </Link>

        <div className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <form onSubmit={handleSearch} className="flex items-center gap-2 rounded-full bg-background-100 px-4 py-2 focus-within:ring-2 focus-within:ring-primary-300">
            <i className="ri-search-line text-foreground-500 text-sm" aria-hidden="true"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索漫画 / 作者"
              className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </form>
        </div>

        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-800 lg:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 lg:hidden">
          <div className="flex flex-col gap-1 pt-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-lg px-4 py-3 text-base font-medium transition-colors ${
                    isActive ? "bg-primary-500 text-background-50" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
          <form onSubmit={handleSearch} className="mt-3 flex items-center gap-2 rounded-full bg-background-100 px-4 py-2">
            <i className="ri-search-line text-foreground-500 text-sm" aria-hidden="true"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索漫画 / 作者"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </form>
        </div>
      )}
    </header>
  );
}